import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function DeleteNotificationSubscriptionService(token, data) {

    return axios.post(
        `${CURRENT_API_URL}/amazonNotifications/deleteNotificationSubscription`,data,
        {
            headers: {
                'Authorization': token,
            }
        }
    ).then(res => {

        return res.data;

    }).catch(error => {

        console.log(error);
        notify.NotifyError("Unable to delete notification subscription.");
        return false;

    });

}

export default DeleteNotificationSubscriptionService;